/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatchProductMappingRequestDto } from '../../models/patch-product-mapping-request-dto';
import { ProductMappingRequestModel } from '../../models/product-mapping-request-model';

export interface PatchProductMappingRequest$Params {
  productMappingRequestId: string;
      body: PatchProductMappingRequestDto
}

export function patchProductMappingRequest(http: HttpClient, rootUrl: string, params: PatchProductMappingRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingRequestModel>> {
  const rb = new RequestBuilder(rootUrl, patchProductMappingRequest.PATH, 'patch');
  if (params) {
    rb.path('productMappingRequestId', params.productMappingRequestId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/problem+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductMappingRequestModel>;
    })
  );
}

patchProductMappingRequest.PATH = '/product-mappings/request/{productMappingRequestId}';
